import { createFileRoute } from '@tanstack/react-router'

import { preloadListCustomers } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/customers')({
	validateSearch: paginatedSearchWithSort(['name', 'createdAt', 'email']),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder } }) =>
		await preloadListCustomers(context, {
			query: {
				limit,
				offset,
				q,
				sortBy,
				sortOrder
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.Customers.Title()
	}
})
